module.exports = __webpack_public_path__ + "img/CRC2_TMKI67.7ca4011a.png";